export default __webpack_public_path__ + "static/media/leventkaptan8.e1c66558.jpg";